// Clicking an input group addon's text or icon focuses the group's input, as
// upstream's InputGroupAddon does. Controls in an addon keep their own click:
// buttons, a native select (its chevron is the wrapper's ::after), and a
// Ui::Select, whose open list stays in the addon where upstream portals it.
document.addEventListener("click", (event) => {
  const addon = event.target.closest(".ui-input-group > [data-slot=input-group-addon]")
  if (!addon || event.target.closest("button, ui-select, .ui-native-select")) return

  addon.parentElement.querySelector(":scope > .ui-input")?.focus()
})
